//scroll variable to track window's scroll
var lastScrollTop = 0;
var mobileW = 0;

//vanilla variables for resizing
var w = window,
  d = document,
  e = d.documentElement,
  g = d.getElementsByTagName("body")[0],
  windowWidth = w.innerWidth || e.clientWidth || g.clientWidth,
  windowHeight = w.innerHeight || e.clientHeight || g.clientHeight;

//header image to be window height on homepage
if (document.getElementsByClassName("img-slide").length > 0) {
  let headerImages = document.getElementsByClassName("img-slide");
  let headerImagesLength = headerImages.length;
  for (let i = 0; i < headerImagesLength; i++) {
    headerImages[i].style.height = windowHeight + 10 + "px";
  }
}
resizeWindow();

// Func = limiting Scope for this file
(function () {
  window.onload = function () {
    resizeWindow();
    scrollW();
  };

  window.addEventListener("scroll", function () {
    scrollW();
  });
  window.addEventListener("resize", function () {
    resizeWindow();
  });

  //scroll down click
  if (document.getElementsByClassName("scroll-down").length > 0) {
    document
      .getElementsByClassName("scroll-down")[0]
      .addEventListener("click", function () {
        animateTo("intro");
      });
  }
  // document
  //   .getElementsByClassName("planning-btn")[0]
  //   .addEventListener("click", function (e) {
  //     e.preventDefault();
  //     animateTo(this.getAttribute("href").split("#")[1]);
  //   });

  //mobile burger menu
  document.getElementById("burgerMenu").addEventListener("click", function () {
    let logoUrl = "";
    let image = document.querySelector(".header__logo img");
    if (!this.classList.contains("open")) {
      logoUrl = site_url + "assets/svg/logo_alt.svg";
      this.parentElement.classList.add("open");
      this.classList.add("open");
      document.querySelector(".navigations").classList.add("open");
      image.setAttribute("src", logoUrl);
      console.log(document.querySelector(".navigations"));
    } else {
      logoUrl = site_url + "assets/svg/logo.svg";
      this.classList.remove("open");
      this.parentElement.classList.remove("open");
      document.querySelector(".navigations").classList.remove("open");
      image.setAttribute("src", logoUrl);
    }
  });

  // Scroll to bottom form - START PLANNING BUTTON
  // function doScrollToForm() {
  //   let form = document.getElementById("weddingvenueinquiryform-form");
  //   let position = form.getBoundingClientRect(); // Get element position [x, y]
  //   console.log(position);
  //   let y_axis = position.y - 200;
  //   window.scrollTo({
  //     top: y_axis,
  //     left: position.x,
  //     behavior: "smooth",
  //   });
  // }
  // const START_PLANING_BTN = document.querySelector(".planning-btn");
  // // const START_PLANING_BTN_MB = document.querySelector(".planning-btn-mb");

  // START_PLANING_BTN.addEventListener("click", () => {
  //   doScrollToForm();
  // });
})();

function scrollW() {
  //check scroll down or up for header styles
  let st = window.pageYOffset || document.documentElement.scrollTop;

  if (st > 80) {
    if (st > lastScrollTop) {
      // downscroll code
      if (!document.getElementById("header").classList.contains("internal")) {
        document.getElementById("header").classList.add("internal");
        let logoUrl = site_url + "assets/svg/logo.svg";
        document
          .getElementsByClassName("header__logo")[0]
          .getElementsByTagName("img")[0]
          .setAttribute("src", logoUrl);
      }
    } else {
    }
  } else {
    if (
      document.getElementById("home") &&
      document.getElementById("header").classList.contains("internal")
    ) {
      document.getElementById("header").classList.remove("internal");
      let logoUrl;
      if (windowWidth > 600) {
        logoUrl = site_url + "assets/svg/logo_alt.svg";
        document
          .getElementsByClassName("header__logo")[0]
          .getElementsByTagName("img")[0]
          .setAttribute("src", logoUrl);
      } else {
        logoUrl = site_url + "assets/svg/logo.svg";
      }
    }
    if (
      !document.getElementById("home") &&
      document.getElementById("header").classList.contains("internal")
    ) {
      document.getElementById("header").classList.remove("internal");
      if (windowWidth > 600) {
        let logoUrl = site_url + "assets/svg/logo_alt.svg";
        document
          .getElementsByClassName("header__logo")[0]
          .getElementsByTagName("img")[0]
          .setAttribute("src", logoUrl);
      }
    }
    if (
      (document.getElementById("gallery") ||
        document.querySelector("body.sitemap") ||
        document.querySelector("body.terms-and-conditions")) &&
      !document.getElementById("header").classList.contains("internal")
    ) {
      document.getElementById("header").classList.add("internal");
      let logoUrl = site_url + "assets/svg/logo.svg";
      document
        .getElementsByClassName("header__logo")[0]
        .getElementsByTagName("img")[0]
        .setAttribute("src", logoUrl);
    }
  }
  lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function resizeWindow() {
  //calculate a new window size
  windowWidth = w.innerWidth || e.clientWidth || g.clientWidth;
  windowHeight = w.innerHeight || e.clientHeight || g.clientHeight;

  //header image to be window height on homepage
  if (document.getElementsByClassName("img-slide").length > 0) {
    let headerImages = document.getElementsByClassName("img-slide");
    let headerImagesLength = headerImages.length;
    for (let i = 0; i < headerImagesLength; i++) {
      headerImages[i].style.height = windowHeight + 10 + "px";
    }
  }
}

//animation of scroll vanilla JS
function animateTo(target) {
  var gotoTarget = offset(document.getElementById(target)).top - 100;
  var from = window.pageYOffset;
  var to = gotoTarget;
  var duration = 1300;
  var start = new Date().getTime();

  //time interval
  var timer = setInterval(function () {
    var time = new Date().getTime() - start;
    if (from <= to) {
      var yH = easeInOutQuart(time, from, to - from, duration);
    } else {
      var yH = easeInOutQuart(time, from, -(from - to), duration);
    }
    window.scrollTo(0, yH);
    if (time >= duration) clearInterval(timer);
  }, 1000 / 60);

  window.scrollTo(0, from);
}

//ease movement
function easeInOutQuart(t, b, c, d) {
  if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b;
  return (-c / 2) * ((t -= 2) * t * t * t - 2) + b;
}

//window offset
function offset(el) {
  var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}
